import {useState,useEffect,useRef} from 'react'
import {Stack, Button,InputGroup, FormControl,Modal, Image, Dropdown, Spinner,Row, Col, Offcanvas, Form} from 'react-bootstrap'
import ritebotLogo from '../assets/ritebot.png'
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios"
import '../styles/heybot.css'
import {ReactComponent as SendIcon} from '../assets/send.svg'
import {ReactComponent as GoogleIcon} from '../assets/google.svg'
import { useNavigate } from "react-router-dom";
import { ReactComponent as QuestionIcon } from "../assets/question-mark.svg";
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { ReactComponent as DiscordIcon } from "../assets/discord.svg";
import logoImage from '../assets/DEVELOPER.png'

function DevPlugins() {
    const [showBanner, setShowBanner] = useState(false);
    const navigate = useNavigate()
    document.title = "Developer Plugins"
	function gotoDevPlugins() {
		window.open("https://chatgptplugins.thesamur.ai/", "_blank")
	}
    return (
        <div class=" d-flex justify-content-center">
            <div className="bot-container">
                <Stack className="text-center mx-2 mx-md-5 px-md-5 py-4 vh-100 align-items-center" gap={4}>
                    <Stack className="p-3" direction="horizontal">
                        <h3 className="fw-bold">
						<Image className="heybot-logo" src={logoImage}/>
                            Developer Plugins
                        </h3>
                    </Stack>
                    
					<h5 className="mt-5 pt-5">Plugins - Use ChatGPT Plugins for free</h5>
					<Button className="option-buttons align-self-center" onClick={()=>gotoDevPlugins()}> Go to Developer Plugins</Button>
                                        <a className="discord-invite px-3 py-3 ms-3" target="_blank" href="https://github.com/SamurAIGPT/ChatGPT-Developer-Plugins"> Find sample plugin on Github</a>
                </Stack>
            </div>
            <ToastContainer />	
            <Modal className="banner-modal" centered show={showBanner} onHide={()=>setShowBanner(false)}>
                <Modal.Body className="p-5 position-relative">
                <b style={{cursor:'pointer'}} onClick={()=>setShowBanner(false)} className="position-absolute top-0 end-0 me-4 mt-2">X</b>
                <Stack className="align-items-center" gap={3}>
                    <a href="https://www.producthunt.com/posts/developer-mode-for-chatgpt-plugins?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-developer&#0045;mode&#0045;for&#0045;chatgpt&#0045;plugins" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=392168&theme=light" alt="Developer&#0032;mode&#0032;for&#0032;ChatGPT&#0032;Plugins - Build&#0032;your&#0032;own&#0032;plugins&#0032;for&#0032;ChatGPT | Product Hunt" style="width: 250px; height: 54px;" width="250" height="54" /></a>
                </Stack>
                </Modal.Body>
            </Modal>
		
        </div>
    )
}

export default DevPlugins